module.exports = __webpack_public_path__ + "static/media/Logo Jayakarta.news.6586addb.png";